<template>
  <div class="text--primary">
    <v-row dense>
      <v-col cols="12" sm="6">
        {{ aprovacao.identificador }}
        <px-requisicao-urgencia :urgencia="aprovacao.urgencia"/>
        <px-situacao-aprovacao :situacao="aprovacao.situacao"/>
      </v-col>
      <v-col cols="12" sm="6" class="text-right">
        <px-aprovacao-solicitacao-controls show-as-buttons
                                           :aprovacao="aprovacao"
                                           @update="onUpdate"/>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="9" class="text-truncate">
        <v-icon small>mdi-pound</v-icon>
        <span class="font-weight-bold">Código:</span>
        {{ aprovacao.id }}
      </v-col>
    </v-row>
    <v-row dense v-if="aprovacao.codigoInterno">
      <v-col cols="12" sm="9" class="text-truncate">
        <v-icon small>mdi-pound</v-icon>
        <span class="font-weight-bold">Código interno:</span>
        {{ aprovacao.codigoInterno }}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">
          Local de faturamento <v-icon small>mdi-map-marker-check</v-icon>
        </span>
        <v-row dense>
          <v-col cols="12">
            {{ aprovacao.comprador.pessoa.nome }} ({{ aprovacao.comprador.pessoa.cnpj | cnpj }})
            <div class="">
              {{ aprovacao.comprador.endereco | endereco }}
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">
          Local de entrega <v-icon small>mdi-map-marker</v-icon>
        </span>
        <v-row dense>
          <v-col cols="12">
            {{ aprovacao.locaisEntrega.nomeLocal }}
            <span v-if="aprovacao.locaisEntrega.codigoInterno">
              ({{ aprovacao.locaisEntrega.codigoInterno }})
            </span>
            <div class="">
              {{ aprovacao.locaisEntrega.endereco | endereco }}
            </div>
            <div class="mt-1" v-if="aprovacao.dataEntrega">
              <v-icon small left>mdi-calendar</v-icon>
              <span class="font-weight-bold">Entrega em </span>
              {{ aprovacao.dataEntrega | date }}
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Centro de custo</span>
        <div>
          {{ centroCusto | naoInformado }}
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Projeto</span>
        <div>
          {{ projeto | naoInformado }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Solicitante</span>
        <div>
          {{
            (aprovacao.usuario ?
              aprovacao.usuario.nome : aprovacao.nomeResponsavel) | naoInformado
          }}
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Finalidade da Compra</span>
        <div v-if="aprovacao.finalidadeCompra">
          <px-finalidade-compra-value :finalidade-compra="aprovacao.finalidadeCompra"/>
        </div>
        <div v-else>
          Não Informado
        </div>
      </v-col>
      <v-col cols="12" sm="6">
        <span class="caption font-weight-bold">{{ labelCompradorResponsavel }}</span>
        <div>
          {{ compradoresResponsaveis | naoInformado }}
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Observações internas</span>
        <div>
          <px-show-large-text :large-text="aprovacao.observacaoInterna"/>
        </div>
      </v-col>
      <v-col cols="12" sm="3">
        <span class="caption font-weight-bold">Observações externas</span>
        <div>
          <px-show-large-text :large-text="aprovacao.observacaoExterna"/>
        </div>
      </v-col>
      <v-col cols="12" sm="6" v-if="aprovacao.arquivos && aprovacao.arquivos.length">
        <span class="caption font-weight-bold">Anexos</span>
        <px-anexo-chip :files="aprovacao.arquivos"
                       download-base-path="files/download-comprador"/>
      </v-col>
    </v-row>
     <px-campos-integracao v-if="cadastrosAdicionais"
                                type="requisicao-view"
                                :form-data="cadastrosAdicionais"/>
    <v-row v-if="isCancelado">
      <v-col cols="12">
        <span class="caption font-weight-bold">Motivo do cancelamento</span>
        <div>
          Acesse o detalhe do item para saber o motivo do cancelamento.
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { descWithCodigoInterno } from '@/utils/object-utils';
import { SituacaoAprovacao } from 'px-business-components';
import { cadastrosAdicionaisToMap } from '@/utils/campos-integracao-utils';
import AprovacaoSolicitacaoControls
  from '@/modules/aprovacao-solicitacao/components/AprovacaoSolicitacaoControls.vue';

export default {
  props: {
    aprovacao: {
      type: Object,
    },
  },
  computed: {
    centroCusto() {
      return this.aprovacao.centroCusto
        ? descWithCodigoInterno(this.aprovacao.centroCusto) : null;
    },
    projeto() {
      return this.aprovacao.projeto
        ? descWithCodigoInterno(this.aprovacao.projeto) : null;
    },
    compradoresResponsaveis() {
      if (!this.aprovacao.compradoresResponsaveis) {
        return null;
      }
      return this.aprovacao.compradoresResponsaveis
        .map(user => user.nome)
        .join(', ');
    },
    labelCompradorResponsavel() {
      return this.aprovacao.compradoresResponsaveis
      && this.aprovacao.compradoresResponsaveis.length > 1 ? 'Compradores responsáveis' : 'Comprador responsável';
    },
    isCancelado() {
      return SituacaoAprovacao.keys.RECUSADO.key === this.aprovacao.situacao;
    },
    cadastrosAdicionais() {
      if (!this.aprovacao.cadastrosAdicionais || !this.aprovacao.cadastrosAdicionais.length) {
        return null;
      }
      return cadastrosAdicionaisToMap(this.aprovacao.cadastrosAdicionais);
    },
  },
  methods: {
    onUpdate(aprovacaoAtualizada) {
      this.$emit('update', aprovacaoAtualizada);
    },
  },
  components: {
    pxAprovacaoSolicitacaoControls: AprovacaoSolicitacaoControls,
  },
};
</script>
